import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
export default class StatusBadge extends Component {
  view() {
    const status = this.attrs.status;
    if (!status) return null;
    const style = {};
    if (status.color()) style.background = status.color();
    if (status.textColor()) style.color = status.textColor();
    return m("span", {
      className: classList('NhStatus', this.attrs.className),
      style: style,
      title: status.name()
    }, status.name());
  }
}
flarum.reg.add('neverhack-forum-nodes', 'forum/components/StatusBadge', StatusBadge);